import { render, staticRenderFns } from "./ExercisesIntroduceAccent.vue?vue&type=template&id=7051ad76"
import script from "./ExercisesIntroduceAccent.vue?vue&type=script&lang=js"
export * from "./ExercisesIntroduceAccent.vue?vue&type=script&lang=js"
import style0 from "./ExercisesIntroduceAccent.vue?vue&type=style&index=0&id=7051ad76&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports